<div *ngIf="allErrors.length > 0">
  <div
    *ngFor="let errorCategory of allErrors"
    [ngClass]="editModifyFlag ? 'mt-2' : 'mt-2'"
  >
    <div
      class="warnings-block rounded mb-3"
      [ngClass]="{ 'no-border': !errorCategory.show }"
      *ngIf="errorCategory.totalWarnings"
    >
      <div
        class="singlet-error-header h-8 rounded flex items-center px-3.5 cursor-pointer"
        (click)="openDescription(errorCategory)"
      >
        <img src="/assets/images/warning-sign.svg" alt="Edit" />
        <span style="width: 100%">
          <span class="validation-header pl-2">{{
            errorCategory.validationType
          }}</span>
          <span class="error-count pl-2">
            ({{ errorCategory.totalWarnings }}
            {{ errorCategory.totalWarnings === 1 ? "Warning" : "Warnings" }})
          </span>
        </span>
        <img src="/assets/images/warning-arrow-down.svg" alt="Edit" />
      </div>
      <div class="error-container" *ngIf="errorCategory.show">
        <ul>
          <li
            class="py-2 px-0.5 flex items-center"
            *ngFor="let warning of errorCategory.warnings"
          >
            <img
              src="/assets/images/arrow-right.svg"
              alt="Edit"
              style="width: 16px; height: 18px"
            />
            <span class="font-normal text-sm leading-normal flex flex-col pl-2">
              <div class="validation-text">
                {{ warning.validation_message }}
              </div>
              <div class="recommendation-text pt-2">
                {{ warning.recommended_action }}
              </div>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="error-block rounded mb-3"
      [ngClass]="{ 'no-border': !errorCategory.show }"
      *ngIf="errorCategory.totalErrors"
    >
      <div
        class="multiple-errors-header h-8 rounded-md flex items-center px-3.5 cursor-pointer"
        (click)="openDescription(errorCategory)"
      >
        <img src="/assets/images/error-icon.svg" alt="Edit" />
        <span style="width: 100%">
          <span class="validation-header pl-2">{{
            errorCategory.validationType
          }}</span>
          <span class="error-count pl-2">
            ({{ errorCategory.totalErrors }}
            {{ errorCategory.totalErrors === 1 ? "Error" : "Errors" }})
          </span>
        </span>
        <img src="/assets/images/error-arrow-down.svg" alt="Edit" />
      </div>
      <div class="error-container" *ngIf="errorCategory.show">
        <ul>
          <li
            class="py-2 px-0.5 flex items-center"
            *ngFor="let error of errorCategory.errors"
            [ngClass]="{
              'cursor-pointer': errorCategory.category === 'merge_conflicts',
            }"
            (click)="
              errorCategory.category === 'merge_conflicts' &&
                actionErrorEmitCall.emit(errorCategory)
            "
          >
            <img
              src="/assets/images/arrow-right.svg"
              alt="Edit"
              style="width: 16px; height: 18px"
            />
            <span class="font-normal text-sm leading-normal flex flex-col pl-2">
              <span class="validation-text"
                >{{ error.validation_message }}
                <span class="text-xs"
                  ><ng-container *ngIf="getFormattedColumn(error)"
                    >[{{ getFormattedColumn(error) }}]</ng-container
                  ></span
                ></span
              >
              <span class="recommendation-text pt-2">{{
                error.recommended_action
              }}</span>
              <span class="pt-2"><b>Column: </b>{{ error.column }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isValidationDataEmpty()">
  <div
    class="success-block flex flex-col justify-center items-center rounded-lg py-3 mt-2 mb-2"
    *ngIf="uploadStatus && editModifyFlag"
  >
    <img src="/assets/images/timer.svg" alt="No Data" class="w-11 h-11" />
    <div class="font-semibold text-2xl py-2">Success</div>
    <div class="font-normal text-base success-label">
      The modifications have been done and
    </div>
    <div class="font-normal text-base success-label">
      data will be reflected
    </div>
    <button class="w-16 h-8 bg-black rounded text-base text-white mt-12">
      OK
    </button>
    <div class="text-xs success-label pt-1">Auto closes after 03 seconds</div>
  </div>

  <!-- Create Assortment Validation Success -->
  <div
    class="validation-success mb-3"
    *ngIf="!editModifyFlag || isValidationSuccess"
  >
    <span class="success-icon"></span>
    <span style="margin-left: 12px"> Validation successful. </span>
  </div>
</div>
